module.exports = __webpack_public_path__ + "img/hohlsaum_verkehrsgelb_ral1023.e6d087d1.jpg";